import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.chat');
import { OnInit, AfterViewInit, ViewChild, Input, ElementRef, NgZone } from "@angular/core";
import { Service } from "src/libs/portal/season/service";
import { Markdown } from "../../libs/markdown.ts";
import showdown from "showdown";

@Component({
    selector: 'wiz-component-chat',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.chat/view.scss */
@charset "UTF-8";
@keyframes fadeSlide {
  0% {
    background-position: 0% 50%;
    transform: scale(1);
  }
  50% {
    background-position: 100% 50%;
    transform: scale(1.05);
  }
  100% {
    background-position: 0% 50%;
    transform: scale(1);
  }
}
.search-animation {
  font-weight: bold;
  font-size: 14px;
  background: linear-gradient(to right, #4a4a4a, #888888, #4a4a4a);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  animation: fadeSlide 1.5s infinite linear;
}

/* Webkit 기반(Chrome/Edge/Safari 등) */
::-webkit-scrollbar {
  display: none;
}

::-webkit-scrollbar-thumb {
  display: none;
}

::-webkit-scrollbar-track {
  background: transparent;
}

.loading-dots .dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  margin: 0 1px;
  opacity: 0.5;
  animation: dot-blink 1.4s infinite both;
}

.loading-dots .dot:nth-child(1) {
  animation-delay: 0s;
}

.loading-dots .dot:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-dots .dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dot-blink {
  0%, 80%, 100% {
    opacity: 0.5;
  }
  40% {
    opacity: 1;
  }
}
.markdown-body p {
  margin-top: 0rem !important;
  margin-bottom: 0rem importatn;
  color: #6b7280;
}

.word-break {
  word-break: keep-all;
}`],
})
export class ComponentChatComponent implements OnInit, AfterViewInit {
    constructor(@Inject( Service) public service: Service,@Inject( NgZone)  private zone: NgZone) { }

    @ViewChild('scroll') public scrollElement!: ElementRef;
    @ViewChild('messageInput', { static: false }) public messageInput!: ElementRef;

    @Input() app: any;

    public messages: { text: string, isMine: boolean, datetime?: string }[] = [];
    public isStreaming: boolean = false;
    private streamingText: string = "";
    private converter: showdown.Converter;
    private isAutoScrollEnabled: boolean = true;
    private lastScrollTop: number = 0;
    private enterPressed = false;
    public faqList: any[] = [];
    public faqSlidePages: any[][] = [];
    public faqSlideIndex: number = 0;
    public isInputDisabled: boolean = false;
    private touchStartX: number = 0;
    public isDropdownOpen: boolean = false;
    public userMessageId: string = "";    public threadId: string = "";

    public async ngOnInit() {
        await this.loadFAQs();
        await this.service.init();
        await this.service.render();
        await wiz.call("visit");
        document.addEventListener('click', this.onClickOutside.bind(this));
        this.converter = new showdown.Converter({
            tables: true, strikethrough: true, emoji: true,
            tasklists: true, simplifiedAutoLink: true,
            openLinksInNewWindow: true, ghCompatibleHeaderId: true,
            underline: true, backslashEscapesHTMLTags: false,
            literalMidWordUnderscores: true, parseImgDimensions: true,
            disableForced4SpacesIndentedSublists: true,
            literalMidWordAsterisks: true, noHeaderId: false,
            requireSpaceBeforeHeadingText: true, simpleLineBreaks: false,
        });

        const styleElement = document.createElement("style");
        styleElement.innerHTML = new Markdown().css();
        document.head.appendChild(styleElement);

        this.zone.runOutsideAngular(() => {
            this.scrollElement.nativeElement.addEventListener("scroll", () => this.onScroll());
        });
    }

    public ngAfterViewInit() {
        const slider = document.querySelector('.faq-slider');
        if (slider) {
            slider.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
            slider.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
        }
        this.shouldScrollToBottom = true;
    }

    public parseMarkdown(text: string): string {
        if (!text || typeof text !== 'string') return "";
        const rawHtml = this.converter.makeHtml(text)
            .replace(/&lt;/g, "<").replace(/&gt;/g, ">")
            .replace(/&quot;/g, '"').replace(/&#39;/g, "'")
            .replace(/&amp;/g, "&");
        return rawHtml.replace(
            /<a href="(.*?)">(.*?)<\/a>/g,
            `<a href="$1" class="inline-flex items-center gap-1 text-blue-600 underline hover:text-blue-800" target="_blank" rel="noopener noreferrer">
                $2<span class="mr-1">🔗</span>
            </a>`
        );
    }

    public async sendMessage() {
        if (this.isStreaming || this.isInputDisabled) return;

        const inputElement = this.messageInput.nativeElement
        const userMessage = inputElement.value.trim();
        if (!userMessage) return;

        this.isInputDisabled = true;
        this.isStreaming = true;

        this.messages.push({
            text: userMessage,
            isMine: true,
            datetime: this.getNowTimeString()
        });

        const loadingMessage: any = { text: "", isMine: false, isLoading: true, isSearching: false };
        this.messages.push(loadingMessage);

        inputElement.value = '';
        inputElement.style.height = "auto";
        inputElement.style.overflowY = "auto";

        this.isAutoScrollEnabled = true;
        this.scrollToBottom(true);
        await this.service.render();

        try {
            const formData = new FormData();
            formData.append("query", userMessage);

            const response = await wiz.call("create_thread_id");
            this.threadId = response.data;

            await wiz.call("save_message", {
                role: "user",
                content: userMessage,
                category: 'qna',
                thread_id: this.threadId
            });

            await this.initEventSource(formData, 'general_generate', loadingMessage);
        } catch (e) {
            console.error(e);
            this.isStreaming = false;
            this.isInputDisabled = false;
            loadingMessage.isLoading = false;
            loadingMessage.text = "죄송합니다. 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.";
            await this.service.render();
        }
    }

    private async initEventSource(formData: FormData, function_name: string, loadingMessage: any) {
        const url = wiz.url('stream');
        this.streamingText = "";
        this.isAutoScrollEnabled = true;
        this.scrollToBottom(true);
        this.isStreaming = true;
        await this.service.render();

        let ansThreadId: string | null = null;
        let ttft: string | null = null;
        try {
            formData.append("function_name", function_name);
            formData.append("thread_id", this.threadId);
            const response = await fetch(url, { method: "POST", body: formData });
            if (!response.body) throw new Error("No stream body");

            const reader = response.body.getReader();
            const decoder = new TextDecoder("utf-8");
            let isStreaming = true;
            while (isStreaming) {
                const { value, done } = await reader.read();
                if (done || !this.isStreaming) break;

                const chunk = decoder.decode(value, { stream: true });

                const events = chunk.split('\n');
                for (const event of events) {
                    if (!event.trim() || !event.startsWith("data:")) continue;
                    if (!this.isStreaming) return;

                    try {
                        const jsonData = JSON.parse(event.replace(/^data:/, "").trim());
                        if (jsonData.name === "thread_id") {
                            ansThreadId = jsonData.data;
                        }

                        if (jsonData.name === "ttft") {
                            ttft = jsonData.data;
                        }

                        if (jsonData.type === "finish") {
                            isStreaming = false;
                            this.isStreaming = false;
                            if (this.streamingText.trim()) {
                                await wiz.call("save_message", {
                                    role: "llm",
                                    content: this.streamingText.trim(),
                                    category: 'qna',
                                    thread_id: ansThreadId,
                                    ttft: ttft

                                });
                            }
                            loadingMessage.isLoading = false;
                            loadingMessage.isSearching = false;
                            this.isInputDisabled = false;
                            setTimeout(() => {
                                this.messageInput?.nativeElement?.focus();
                            }, 0);
                            await this.service.render();
                            break;
                        }
                        if (jsonData.type === "log" && jsonData.data && jsonData.data.type === "weather") {
                            this.messages.pop();
                            this.messages.push(jsonData.data);
                            await this.service.render();
                            this.scrollToBottom(true);
                            continue;
                        }

                        if (jsonData.type === "output") continue;
                        if (typeof jsonData.data === "string") {
                            this.streamingText += jsonData.data?.replace(/¤/g, ' ') ?? "";
                            loadingMessage.text = this.parseMarkdown(this.streamingText);
                            loadingMessage.isLoading = false;
                            await this.service.render();
                            if (this.isAutoScrollEnabled) {
                                this.scrollToBottom();
                            }
                        }
                    } catch (parseError) {
                        console.error("Error parsing JSON stream data:", parseError, "Received data:", event);
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching SSE data:", error);
            loadingMessage.isLoading = false;
            loadingMessage.text = "죄송합니다. 메시지를 가져오는 중에 오류가 발생했습니다.";
        } finally {
            this.isStreaming = false;
            this.isInputDisabled = false;
            await this.service.render();
        }
    }

    public stopStreaming() {
        this.isStreaming = false;
        this.messages.forEach(msg => {
            if (msg.isLoading || msg.isSearching) {
                msg.isLoading = false;
                msg.isSearching = false;
            }
        });
        this.shouldScrollToBottom = true;
        this.service.render();
    }

    public async adjustTextareaHeight() {
        const inputElement = this.messageInput.nativeElement;
        inputElement.style.height = "auto";
        inputElement.style.height = `${Math.min(inputElement.scrollHeight, 200)}px`;
        inputElement.style.overflowY = inputElement.scrollHeight > 200 ? "scroll" : "hidden";
        await this.service.render();
    }

    public handleEnter(event: KeyboardEvent) {
        if (this.isStreaming || this.enterPressed) {
            event.preventDefault();
            return;
        }
        if (event.key === "Enter") {
            event.preventDefault();
            this.enterPressed = true;
            setTimeout(async () => {
                await this.sendMessage();
                this.enterPressed = false;
            }, 0);
        }
    }

    public onScroll() {
        const scrollElement = this.scrollElement.nativeElement;
        const currentScroll = scrollElement.scrollTop + scrollElement.clientHeight;
        const isAtBottom = currentScroll >= scrollElement.scrollHeight - 1;
        if (scrollElement.scrollTop < this.lastScrollTop) {
            this.isAutoScrollEnabled = false;
        } else if (isAtBottom) {
            this.isAutoScrollEnabled = true;
        }
        this.lastScrollTop = scrollElement.scrollTop;
    }

    private scrollToBottom(force = false) {
        const scrollElement = this.scrollElement?.nativeElement;
        if (!scrollElement) return;

        if (force) {
            requestAnimationFrame(() => {
                scrollElement.scrollTo({
                    top: scrollElement.scrollHeight,
                    behavior: "smooth"
                });
            });
        } else if (this.isAutoScrollEnabled) {
            requestAnimationFrame(() => {
                scrollElement.scrollTo({
                    top: scrollElement.scrollHeight,
                    behavior: "smooth"
                });
            });
        }
    }

    public async loadFAQs() {
        const res = await wiz.call("load_faqs");
        const list = res?.data?.data || [];
        this.faqList = list;

        const pageSize = 6;
        this.faqSlidePages = [];
        for (let i = 0; i < list.length; i += pageSize) {
            this.faqSlidePages.push(list.slice(i, i + pageSize));
        }
        this.faqSlideIndex = 0;
    }

    public async selectFAQ(faq: any) {
        if (this.isStreaming) return;
        this.messages.push({ text: faq.question, isMine: true, datetime: this.getNowTimeString() });
        this.isAutoScrollEnabled = true;
        this.scrollToBottom(true);
        await this.service.render();

        await wiz.call("increase_faq_count", { id: faq.id });

        const response = await wiz.call("create_thread_id");
        const threadId = response.data

        await wiz.call("save_message", {
            role: "user",
            content: faq.question,
            category: 'faq',
            thread_id: threadId
        });

        const answerMessage = { text: "", isMine: false };
        this.messages.push(answerMessage);
        await this.service.render();
        this.scrollToBottom(true);

        await wiz.call("save_message", {
            role: "llm",
            content: faq.answer,
            category: 'faq',
            thread_id: threadId
        });


        const answer = faq.answer;
        let index = 0;
        let lastScrollAt = 0;
        const SCROLL_THROTTLE = 80;
        const speed = 15;

        const type = async () => {
            if (index < answer.length) {
                answerMessage.text += answer[index];
                index++;
                await this.service.render();

                const now = Date.now();
                if (this.isAutoScrollEnabled && now - lastScrollAt > SCROLL_THROTTLE) {
                    this.scrollToBottom(false);
                    lastScrollAt = now;
                }

                setTimeout(type, speed);
            }
        };
        type();
    }

    public nextFAQSlide() {
        if (this.faqSlideIndex < this.faqSlidePages.length - 1) {
            this.faqSlideIndex++;
        }
        this.service.render();
        this.shouldScrollToBottom = true;
    }

    public prevFAQSlide() {
        if (this.faqSlideIndex > 0) {
            this.faqSlideIndex--;
        }
        this.service.render();
        this.shouldScrollToBottom = true;
    }

    public goToFAQSlide(index: number) {
        this.faqSlideIndex = index;
        this.service.render();
        this.shouldScrollToBottom = true;
    }

    private onTouchStart(event: TouchEvent) {
        this.touchStartX = event.touches[0].clientX;
    }

    private onTouchEnd(event: TouchEvent) {
        const touchEndX = event.changedTouches[0].clientX;
        const diffX = touchEndX - this.touchStartX;
        if (Math.abs(diffX) > 50) {
            if (diffX < 0 && this.faqSlideIndex < this.faqSlidePages.length - 1) {
                this.nextFAQSlide();
            } else if (diffX > 0 && this.faqSlideIndex > 0) {
                this.prevFAQSlide();
            }
        }
    }

    public toggleDropdown(event: MouseEvent) {
        event.stopPropagation();
        this.isDropdownOpen = !this.isDropdownOpen;
        this.service.render();
    }

    public resetChat(event: MouseEvent) {
        event.stopPropagation();
        this.messages = [];
        this.isDropdownOpen = false;
        this.service.render();
        this.shouldScrollToBottom = true;
    }

    private onClickOutside(event: MouseEvent) {
        if (this.isDropdownOpen) {
            this.isDropdownOpen = false;
            this.service.render();
        }
    }

    public getNowTimeString(): string {
        const now = new Date();
        let hour = now.getHours();
        const minute = now.getMinutes().toString().padStart(2, '0');
        const ampm = hour < 12 ? '오전' : '오후';
        if (hour === 0) hour = 12;
        else if (hour > 12) hour -= 12;
        return `${ampm} ${hour}:${minute}`;
    }

}

export default ComponentChatComponent;